import axios from "@/util/axios";

const PREFIX_URI = "/order/product/assembly/template";

export default {
    /** 分页查询模板列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 查询模板详情（含明细） */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存模板 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 删除模板 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 启用/停用模板 */
    updateStatus: (id, status) => axios.get({url: `${PREFIX_URI}/updateStatus`, data: {id, status}}),
}
